const styles = theme => ({
  mobileHeader: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    background: theme.palette.primary.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px 16px 16px',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    zIndex: '100',
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  heading: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
  },

  btn: {
    minWidth: 'auto',
    background: 'transparent',
    boxShadow: 'none',
    '&:hover': {
      background: 'transparent',
      boxShadow: 'none',
    },
  },

  backBtn: {
    marginRight: '14px',
    padding: '0',
  },

  showFiltersBtn: {
    padding: '4px',
  },
});

export default styles;
